module.exports = __webpack_public_path__ + "prod/1.42.2/img/api-two.d8fcae4e.png";